import {
  ApiResponse,
  InitOverrideFunction,
  TranslatorApi,
  TranslatorCancelTranslationPostRequest,
  TranslatorTranslateFilePostRequest,
  TranslatorTranslateTextPostRequest,
  TranslatorTranslateWithGlossaryTextPostRequest,
} from "../../../@api";

export class TranslationApiService
  implements Omit<TranslatorApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: TranslatorApi) {}

  public translatorTranslateTextPost(
    requestParameters?: TranslatorTranslateTextPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.translatorTranslateTextPost(requestParameters, initOverrides);
  }

  public translatorTranslateWithGlossaryTextPost(
    requestParameters: TranslatorTranslateWithGlossaryTextPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.translatorTranslateWithGlossaryTextPost(requestParameters, initOverrides);
  }

  public translatorTranslateTextPostRaw(
    requestParameters: TranslatorTranslateTextPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.translatorTranslateTextPostRaw(requestParameters, initOverrides);
  }

  public translatorTranslateTextWithGlossaryPostRaw(
    requestParameters: TranslatorTranslateWithGlossaryTextPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.translatorTranslateWithGlossaryTextPostRaw(requestParameters, initOverrides);
  }

  public translatorTranslateFilePost(
    requestParameters?: TranslatorTranslateFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.translatorTranslateFilePost(requestParameters, initOverrides);
  }

  public translatorTranslateFilePostRaw(
    requestParameters: TranslatorTranslateFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.translatorTranslateFilePostRaw(requestParameters, initOverrides);
  }

  public translatorCancelTranslationPost(
    requestParameters?: TranslatorCancelTranslationPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.translatorCancelTranslationPost(requestParameters, initOverrides);
  }
}
